import React, { useEffect, useState } from "react";
import ResponsiveGallery from "react-responsive-gallery";
import "./App.css";
import Table from "./Table";

function getFolder(url) {
  // Używamy wyrażenia regularnego, aby znaleźć tekst po "stable-diffusion/"
  const match = url.match(/stable-diffusion\/([^/]+)/);

  if (match && match[1]) {
    const nazwaFolderuPoStableDiffusion = match[1];
    console.log(
      'Nazwa folderu po "stable-diffusion":',
      nazwaFolderuPoStableDiffusion
    );
    return nazwaFolderuPoStableDiffusion;
  } else {
    console.log('Nie znaleziono folderu po "stable-diffusion"');
  }
}

function App() {
  const [jsonData, setJsonData] = useState(null);
  const [jsonDataFolders, setJsonDataFolders] = useState(null);
  const [jsonDataAll, setJsonDataAll] = useState(null);
  const [isInFolder, setIsInFolder] = useState(false);
  const [selected, setSelected] = useState();

  const fetchImages = () => {
    fetch(`https://lublin-hydraulik.pl/stable-diffusion/folder.php`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setJsonDataAll(data);
        const newObject = [];
        Object.keys(data).forEach(function (key) {
          newObject.push(data[key][0]);
        });
        newObject.reverse();
        console.log("data");
        setJsonData(newObject);
        setJsonDataFolders(newObject);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  useEffect(() => {
    fetchImages();
  }, []);

  function transformData(jsonData) {
    if (!jsonData || !Array.isArray(jsonData)) {
      return []; // Zwraca pustą tablicę w przypadku błędnych danych wejściowych.
    }

    return jsonData.map((file) => ({ src: file }));
  }
  const images = transformData(jsonData);

  const onClickFolder = (item) => {
    const folderName = getFolder(item);
    setJsonData(jsonDataAll[folderName]);
    setIsInFolder(true);
  };

  const onClickBack = () => {
    setSelected(null);
    setJsonData(jsonDataFolders);
    setIsInFolder(false);
  };
  return (
    <>
      {!isInFolder && (
        <div id="res">
          <ResponsiveGallery
            onSelect={onClickFolder}
            selectable
            images={images}
          />
        </div>
      )}
      {isInFolder && (
        <>
          <button onClick={onClickBack} className="back-button">
            back
          </button>

          <Table imageUrl={selected} />
          <div id="in">
            <ResponsiveGallery
              useLightBox
              images={images}
              selectable
              onSelect={(url) => {
                setSelected(url);
              }}
            />
          </div>
        </>
      )}
    </>
  );
}

export default App;
